import { Button, Card, TextField, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, Divider, Menu, MenuItem } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { BookOutlined } from "@material-ui/icons";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import RedoIcon from '@material-ui/icons/Redo';
import UserIcon from '@material-ui/icons/PersonOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import WarningIcon from '@material-ui/icons/Warning';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import DescriptionIcon from '@material-ui/icons/Description';
import TableChartIcon from '@material-ui/icons/TableChart';
import { Autocomplete } from '@material-ui/lab';
import CircularProgress from '@mui/material/CircularProgress';
import _ from 'lodash';
import moment from 'moment';
import * as React from "react";
import { ConnectedProps, connect } from 'react-redux';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ModalTypes } from '../../components/Modals/ModalTypes';
import * as ModalsActions from '../../redux/modals/modals.actions';
import { IState } from '../../redux/store';
import * as CreditsActions from '../../redux/credits/credits.actions';
import * as VarsActions from '../../redux/vars/vars.actions';
import * as MksActions from '../../redux/mks/mks.actions';
import { IMKSRequestDTO, IMKSRequestInDTO, IMKSRequestUpdateDTO, IMKSRequestDataKey, IMKSRequestDataCylinder, IMKSRequestDataKeyDuplicate, IMKSRequestDataCylinderDuplicate } from '../../repository/jago/model/output/IMKSRequestDTO';
import { IUserInDTO } from '../../repository/jago/model/input/IUserInDTO';
import { IKeyInDTO } from '../../repository/jago/model/input/IKeyInDTO';
import { ICylinderInDTO } from '../../repository/jago/model/input/ICylinderInDTO';
import { IWalletPlantsRequestParamsDTO, ICylindersRequestParamsDTO, IKeysRequestParamsDTO } from '../../repository/jago/model/output/RequestParamsDTOs';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import translations from '../../translations/i18next';
import ReduxLanguage from "../ReduxLanguage";
import MKSRequestHistoryList from '../MKS/MKSRequestHistoryList';
import { MKSRequestStatusOptions, MKSRequestTypeOptions } from '../MKS/MKSRequestsTable';
import { getDomainsOptions } from "../../repository/utils";
import { IDomainOptionDTO } from "../../repository/jago/model/input/IDomainOptionDTO";
import { IVarInDTO } from "../../repository/jago/model/input/IVarInDTO";
import { VAR_USERS_ROLES } from "../../utils/Utils";
import MksKeyForm from "./MksKeyForm";
import MksCylinderForm from "./MksCylinderForm";
import { GREEN } from "../../style/StyleConsts";

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    height: '130vh',
    flex: 1,
  },
  formTitle: {
    fontWeight: 'bold',
    marginBottom: 20,
  },
  errorText: {
    color: 'red'
  },
  inputTitle: {
    marginTop: 20,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  disabledButton: {
    backgroundColor: 'red'
  },
  inputTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  italicText: {
    fontStyle: 'italic',
  },
  actionButton: {
    width: 'fit-content',
    color: 'white',
    marginLeft: 20,
    padding: 4,
    paddingLeft: 10,
    paddingRight: 10,
    fontWeight: 'bold'
  },
  actionButtonText: {
    margin: 0,
    fontWeight: 'bold',
  },
  icon: {
    fontSize: 15,
    marginRight: 5,
  },
  iconCustomer: {
    fontSize: 20,
    marginRight: 10,
    color: 'darkcyan',
  },
});

export interface IRequestTypeOption {
  label: string;
  value: string;
}

const getRequestTypeOptions = (): IRequestTypeOption[] => [
  { label: translations.t('mks.requestType_KEY_DUPLICATION'), value: MKSRequestTypeOptions.KEY_DUPLICATION },
  { label: translations.t('mks.requestType_CYLINDER_DUPLICATION'), value: MKSRequestTypeOptions.CYLINDER_DUPLICATION },
  { label: translations.t('mks.requestType_KEY_EXTENSION'), value: MKSRequestTypeOptions.KEY_EXTENSION },
  { label: translations.t('mks.requestType_CYLINDER_EXTENSION'), value: MKSRequestTypeOptions.CYLINDER_EXTENSION },
];

export interface IMKSRequestFormState {
  request: IMKSRequestInDTO | IMKSRequestUpdateDTO;
  errors: Record<string, boolean>;
  plantSearchInput: string;
  plantSelected: IDomainOptionDTO | null;
  plantsLoading: boolean;
  plantsOptions: IDomainOptionDTO[];
  assignedUser: IUserInDTO | null;
  selectedFileName: string | null;
  documents: Array<{name: string, contentBase64?: string, url?: string}>;
  data: { [key: string]: string };
  quantityErrors: Record<number, boolean>; // Per tracciare errori di quantità per ogni indice
  batchAddDialogOpen: boolean; // Per gestire l'apertura della dialog di batch add
  batchAddDialogType: 'cylinders' | 'keys' | null; // Tipo di elementi da aggiungere
  batchAddFilterInput: string; // Input di filtro nella dialog
  pdfDialogOpen: boolean; // Per gestire l'apertura della dialog del PDF
  pdfBlobUrl: string | null; // URL del blob del PDF generato
  exportMenuAnchorEl: HTMLElement | null; // Per gestire l'ancor del menu di esportazione
};

export interface IMKSRequestFormProps extends WithStyles<typeof styles> {
  onCreateEditMKSRequest: (request: IMKSRequestInDTO | IMKSRequestUpdateDTO) => void;
  onCreateAndSendRequest?: (request: IMKSRequestInDTO) => Promise<void>;
  onReloadRequests?: () => void;
  onOpenCustomerInfo?: (customerId: number) => void;
  request?: IMKSRequestDTO;
  varUsers?: any;
  keys?: any;
  cylinders?: any;
  initialRequestType?: string;
  initialPlant?: IDomainOptionDTO;
  initialData?: { [key: string]: string };
}

type IReduxProps = ConnectedProps<typeof connector>;

export type ComponentProps = IMKSRequestFormProps & IReduxProps;

class MKSRequestForm extends React.Component<ComponentProps, IMKSRequestFormState> {
  inputFileRef = null;

  constructor(props: ComponentProps) {
    super(props);
    this.inputFileRef = React.createRef();

    const { initialRequestType, initialPlant, initialData, request } = props;
    
    // Se ci sono dati iniziali, usali per pre-popolare il form
    const initialRequestTypeValue = initialRequestType || (request ? request.requestType : '');
    const initialPlantSelected = initialPlant || null;
    const initialPlantId = initialPlant ? initialPlant.value.id : (request ? null : null);
    let initialDataValue = initialData || (request && request.data ? request.data : {});
    
    // Gestione retrocompatibilità: converti vecchio formato (key+quantity o cylinder+quantity) in array se necessario
    if (request && request.data) {
      try {
        const dataObj = request.data;
        // Controlla se ci sono keysDuplicates o cylindersDuplicates (nuovo formato)
        // Se non ci sono, ma c'è key+quantity o cylinder+quantity, converti
        if (initialRequestTypeValue === MKSRequestTypeOptions.KEY_DUPLICATION) {
          if (!dataObj.keysDuplicates && dataObj.key && dataObj.quantity) {
            // Vecchio formato: converti in array
            const keyData = JSON.parse(dataObj.key);
            if (keyData) {
              const convertedKey: IMKSRequestDataKey = {
                id: keyData.id,
                externalId: keyData.externalId,
                keyFunction: keyData.keyFunction || '',
                designation: keyData.designation || ''
              };
              initialDataValue = {
                ...initialDataValue,
                keysDuplicates: JSON.stringify([{ key: convertedKey, quantity: parseInt(dataObj.quantity) || 1 }])
              };
            }
          }
        } else if (initialRequestTypeValue === MKSRequestTypeOptions.CYLINDER_DUPLICATION) {
          if (!dataObj.cylindersDuplicates && dataObj.cylinder && dataObj.quantity) {
            // Vecchio formato: converti in array
            const cylinderData = JSON.parse(dataObj.cylinder);
            if (cylinderData) {
              const convertedCylinder: IMKSRequestDataCylinder = {
                id: cylinderData.id,
                externalId: cylinderData.externalId,
                doorName: cylinderData.doorName || '',
                marking: cylinderData.marking || '',
                type: cylinderData.type || ''
              };
              initialDataValue = {
                ...initialDataValue,
                cylindersDuplicates: JSON.stringify([{ cylinder: convertedCylinder, quantity: parseInt(dataObj.quantity) || 1 }])
              };
            }
          }
        }
      } catch (e) {
        // Se c'è un errore, continua con i dati originali
      }
    }

    this.state = {
      plantSearchInput: "",
      plantSelected: initialPlantSelected,
      plantsLoading: false,
      plantsOptions: [],
      request: request ? {
        requestType: request.requestType,
        notes: request.notes || '',
        data: request.data || {},
        assignedUserIds: [], // Will be set when varUsers are loaded
      } : {
        requestType: initialRequestTypeValue,
        notes: '',
        plantId: initialPlantId,
        data: initialDataValue,
        assignedUserIds: [],
      },
      assignedUser: null, // Will be set when varUsers are loaded
      selectedFileName: null,
      documents: request && request.documents ? 
        Object.entries(request.documents).map(([name, content]) => ({ 
          name, 
          contentBase64: content.startsWith('http') ? undefined : content, // Se è URL, non mettere contentBase64
          url: content.startsWith('http') ? content : undefined // Se è URL, mettere url
        })) : 
        [],
      data: initialDataValue,
      errors: {
        requestType: false,
        plantId: (request || initialPlantId) ? false : true,
        notes: false,
        data: false,
      },
      quantityErrors: {},
      batchAddDialogOpen: false,
      batchAddDialogType: null,
      batchAddFilterInput: '',
      pdfDialogOpen: false,
      pdfBlobUrl: null,
      exportMenuAnchorEl: null,
    };
  }

  onChangeData(field: string, value: string) {
    const { data, request } = this.state;
    const updatedData = { ...data, [field]: value };
    this.setState({ 
      data: updatedData,
      request: { ...request, data: updatedData }
    });
  }

  toBase64 = (file: File) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Rimuovo la prima parte, i.e. "data:application/pdf;base64,"
      let resultAsString = (reader.result as string);
      let resultSplitted = resultAsString.split(',');
      if (resultSplitted.length>1)
        resolve(resultSplitted[1])
    };
    reader.onerror = reject;
  });

  async onNewInputFile(newFile: File) {
    const { dispatch } = this.props;
    var fileName: string = "";
    var fileExtension: string = "";
    var fileExtSearch: number = newFile&&newFile.name?newFile.name.lastIndexOf("."):-1
    if (fileExtSearch>0&&fileExtSearch<newFile.name.length) {
      fileName = newFile.name.substring(0,fileExtSearch);
      fileExtension = newFile.name.substring(fileExtSearch+1);
    }
    else
      return;
    this.onNewInputFileConfirmed(newFile,fileName,fileExtension)
  }

  async onNewInputFileConfirmed(newFile: File, newName: string, newExtension: string) {
    const { dispatch } = this.props;
    const { selectedFileName, documents } = this.state;

    let encodedFile = null;
    try {encodedFile = await this.toBase64(newFile)} catch(e) {return}
    if (encodedFile===null) return;
    if (selectedFileName!==null) {
      const updatedDocuments = documents.map((item,i) => {
        if (selectedFileName===item.name) return {name:item.name,contentBase64:encodedFile};
        else return item;
      });
      this.setState({ documents: updatedDocuments });
    }
    else {
      if (newName!==null&&newExtension!==null) {
        // Controllo che il nome dato non sia già presente, altrimenti puppa
        let tempSearch = documents.filter(e=>e.name===(newName+"."+newExtension))
        if (tempSearch.length>0) {
          dispatch<any>(ModalsActions.showModal(`NEWFILE_DUPLICATE_NAME_ERROR_MODAL`, {
            modalType: ModalTypes.ERROR_MODAL,
            modalProps: {
              titleMessageKey: 'errors.error',
              errorMessageKey: 'activations.newFileDuplicateNameError',
            }
          }));
          return;
        }
        this.setState({ documents: [...documents, {name:(newName+"."+newExtension),contentBase64:encodedFile}] });
      }
    }
  }

  async componentDidMount() {
    const { VAR, dispatch, request, initialPlant } = this.props;
    const isVar = AbilityProvider.getAbilityHelper().hasRoles(VAR_USERS_ROLES.map(e=>{return e.name}))
    const varId = isVar ? (VAR as IVarInDTO).id : (request ? request.varId : undefined)
    if (varId && AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.VAR_USER_READ))
      await dispatch<any>(VarsActions.fetchVarUsers(varId, { page: 0, pageSize: 500}));
    else
      dispatch<any>(VarsActions.setVarUsers({ content: [], pagination: { totalElements: 0, totalPages: 0, size: 0, number: 0 } }));
    
    // Carica chiavi e cilindri per il plant se disponibile (sia da request che da initialPlant)
    const plantHostname = (request && request.plantHostname) || (initialPlant && initialPlant.value.hostname);
    if (plantHostname) {
      const keysParams: IKeysRequestParamsDTO = { 
        hostname: plantHostname, 
        page: 0, 
        pageSize: 1000 
      };
      const cylindersParams: ICylindersRequestParamsDTO = { 
        hostname: plantHostname, 
        page: 0, 
        pageSize: 1000 
      };
      
      await Promise.all([
        dispatch<any>(MksActions.fetchKeys(keysParams)),
        dispatch<any>(MksActions.fetchCylinders(cylindersParams))
      ]);
    }
  }

  componentDidUpdate(prevProps: ComponentProps) {
    const { varUsers, request } = this.props;
    const { assignedUser } = this.state;
    
    // Se abbiamo caricato gli utenti VAR e non abbiamo ancora impostato l'assignedUser
    if (varUsers && varUsers.content && !assignedUser && request && request.assignedUsers && request.assignedUsers.length > 0) {
      // Trova l'utente corrispondente negli utenti VAR caricati
      const assignedUserFromRequest = request.assignedUsers[0];
      const matchingUser = varUsers.content.find((user: IUserInDTO) => 
        user.username === assignedUserFromRequest.firstName + ' ' + assignedUserFromRequest.lastName ||
        user.email === assignedUserFromRequest.email
      );
      
      if (matchingUser) {
        this.setState({ 
          assignedUser: matchingUser,
          request: { ...this.state.request, assignedUserIds: [matchingUser.id] }
        });
      }
    }
  }

  async onPlantSearchInputChanged(newInputValue: string) {
    const { dispatch } = this.props;
    this.setState({ plantSearchInput: newInputValue })
    if (!newInputValue) {
      this.setState({ plantsLoading: false })
      return;
    }
    this.setState({ plantsLoading: true })
    const params: IWalletPlantsRequestParamsDTO = { page: 0, pageSize: 100, hostname: newInputValue, walletId: undefined };
    const domains = await dispatch<any>(CreditsActions.fetchDomainsSearch(params));
    const domainsOptions = getDomainsOptions(domains);
    this.setState({ plantsLoading: false, plantsOptions: domainsOptions as IDomainOptionDTO[] });
  }

  async onPlantSelected(selectedPlant: IDomainOptionDTO | null) {
    const { dispatch } = this.props;
    const { request } = this.state;
    
    this.setState({ plantSelected: selectedPlant });
    this.onChangeValue('plantId', true, !selectedPlant ? null : selectedPlant.value.id);
    
    // Se è stato selezionato un plant, carica automaticamente chiavi e cilindri
    if (selectedPlant && selectedPlant.value.hostname) {
      const keysParams: IKeysRequestParamsDTO = { 
        hostname: selectedPlant.value.hostname, 
        page: 0, 
        pageSize: 1000 
      };
      const cylindersParams: ICylindersRequestParamsDTO = { 
        hostname: selectedPlant.value.hostname, 
        page: 0, 
        pageSize: 1000 
      };
      
      try {
        await Promise.all([
          dispatch<any>(MksActions.fetchKeys(keysParams)),
          dispatch<any>(MksActions.fetchCylinders(cylindersParams))
        ]);
      } catch (error) {
        console.error('Error loading keys and cylinders:', error);
      }
    }
  }

  onChangeValue(field: string, mandatory: boolean, value?: any) {
    const { request, errors, data } = this.state;
    this.setState({
      errors: { ...errors, [field]: (!value && mandatory) ? true : false }
    });
    (request as any)[field] = value;
    
    // Se cambia il tipo di richiesta o il plant, pulisci i dati specifici per evitare conflitti
    if (field === 'requestType' || field === 'plantId') {
      const updatedData = { ...data };
      // Pulisci i dati specifici per ogni tipo di richiesta
      delete updatedData.quantity;
      delete updatedData.key;
      delete updatedData.cylinder;
      delete updatedData.keys;
      delete updatedData.cylinders;
      delete updatedData.keysDuplicates;
      delete updatedData.cylindersDuplicates;
      
      // Se è stato selezionato un tipo di richiesta di duplicazione, inizializza automaticamente un array con un elemento vuoto
      if (field === 'requestType' && value) {
        if (value === MKSRequestTypeOptions.KEY_DUPLICATION) {
          updatedData.keysDuplicates = JSON.stringify([{ key: null as any, quantity: undefined as any }]);
        } else if (value === MKSRequestTypeOptions.CYLINDER_DUPLICATION) {
          updatedData.cylindersDuplicates = JSON.stringify([{ cylinder: null as any, quantity: undefined as any }]);
        }
      }
      
      this.setState({ 
        request: { ...request, data: updatedData },
        data: updatedData,
        quantityErrors: {} // Pulisci anche gli errori di quantità
      });
    } else {
      this.setState({ request });
    }
  }


  onChangeAssignedUser(assignedUser: IUserInDTO | null) {
    const { request } = this.state;
    const assignedUserIds = assignedUser ? [assignedUser.id] : [];
    this.setState({ 
      assignedUser,
      request: { ...request, assignedUserIds }
    });
  }

  onSubmitForm() {
    const { request, documents, data } = this.state;
    const { request: editRequest, onCreateAndSendRequest } = this.props;
    const isEdit = Boolean(editRequest);
    
    // Valida e imposta errori per le quantità prima di controllare canSubmitForm
    this.validateQuantities();
    
    if (!this.canSubmitForm())
      return;

    // Piazzo i documents che sono stati aggiunti || aggiornati (solo quelli con contentBase64)
    let newDocuments = {};
    for (let i=0; i<documents.length; i++) {
      if (documents[i].name && documents[i].contentBase64) {
        newDocuments[documents[i].name] = documents[i].contentBase64;
      }
    }
    
    // Prepara i dati della richiesta
    const processedData = { ...data };
    
    // Gestione nuovo formato: keysDuplicates e cylindersDuplicates
    // Se c'è il nuovo formato, assicurati che sia valido e rimuovi il vecchio formato
    if (request.requestType === MKSRequestTypeOptions.KEY_DUPLICATION) {
      if (processedData.keysDuplicates) {
        try {
          const duplicatesArray = JSON.parse(processedData.keysDuplicates);
          // Valida e filtra elementi validi
          const validDuplicates = duplicatesArray.filter((dup: IMKSRequestDataKeyDuplicate) => 
            dup && dup.key && dup.key.id && dup.quantity && dup.quantity > 0
          );
          if (validDuplicates.length > 0) {
            processedData.keysDuplicates = JSON.stringify(validDuplicates);
            // Rimuovi vecchio formato se presente
            delete processedData.key;
            delete processedData.quantity;
          } else {
            delete processedData.keysDuplicates;
          }
        } catch (e) {
          // Se non è JSON valido, rimuovi
          delete processedData.keysDuplicates;
        }
      } else if (processedData.key && processedData.quantity) {
        // Retrocompatibilità: converti vecchio formato in nuovo formato
        try {
          const parsedKey = JSON.parse(processedData.key);
          if (parsedKey && typeof parsedKey === 'object' && parsedKey.id) {
            const convertedKey: IMKSRequestDataKey = {
              id: parsedKey.id,
              externalId: parsedKey.externalId,
              keyFunction: parsedKey.keyFunction || '',
              designation: parsedKey.designation || ''
            };
            processedData.keysDuplicates = JSON.stringify([{ 
              key: convertedKey, 
              quantity: parseInt(processedData.quantity) || 1 
            }]);
            delete processedData.key;
            delete processedData.quantity;
          }
        } catch (e) {
          // Se non è JSON valido, lascia come è
        }
      }
    } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_DUPLICATION) {
      if (processedData.cylindersDuplicates) {
        try {
          const duplicatesArray = JSON.parse(processedData.cylindersDuplicates);
          // Valida e filtra elementi validi
          const validDuplicates = duplicatesArray.filter((dup: IMKSRequestDataCylinderDuplicate) => 
            dup && dup.cylinder && dup.cylinder.id && dup.quantity && dup.quantity > 0
          );
          if (validDuplicates.length > 0) {
            processedData.cylindersDuplicates = JSON.stringify(validDuplicates);
            // Rimuovi vecchio formato se presente
            delete processedData.cylinder;
            delete processedData.quantity;
          } else {
            delete processedData.cylindersDuplicates;
          }
        } catch (e) {
          // Se non è JSON valido, rimuovi
          delete processedData.cylindersDuplicates;
        }
      } else if (processedData.cylinder && processedData.quantity) {
        // Retrocompatibilità: converti vecchio formato in nuovo formato
        try {
          const parsedCylinder = JSON.parse(processedData.cylinder);
          if (parsedCylinder && typeof parsedCylinder === 'object' && parsedCylinder.id) {
            const convertedCylinder: IMKSRequestDataCylinder = {
              id: parsedCylinder.id,
              externalId: parsedCylinder.externalId,
              doorName: parsedCylinder.doorName || '',
              marking: parsedCylinder.marking || '',
              type: parsedCylinder.type || ''
            };
            processedData.cylindersDuplicates = JSON.stringify([{ 
              cylinder: convertedCylinder, 
              quantity: parseInt(processedData.quantity) || 1 
            }]);
            delete processedData.cylinder;
            delete processedData.quantity;
          }
        } catch (e) {
          // Se non è JSON valido, lascia come è
        }
      }
    }
    
    // Prepara il request object
    const requestWithDocuments = { ...request, documents: newDocuments, data: processedData };
    
    // Rimuovi assignedUserIds se è vuoto
    if (!requestWithDocuments.assignedUserIds || requestWithDocuments.assignedUserIds.length === 0) {
      delete requestWithDocuments.assignedUserIds;
    }

    // Se è una nuova richiesta (non edit) e c'è il callback onCreateAndSendRequest, mostra la modale
    if (!isEdit && onCreateAndSendRequest) {
      this.showSendConfirmationModal(requestWithDocuments as IMKSRequestInDTO);
    } else {
      const { onCreateEditMKSRequest } = this.props;
      onCreateEditMKSRequest(requestWithDocuments);
    }
  }

  showSendConfirmationModal(request: IMKSRequestInDTO) {
    const { dispatch, onCreateEditMKSRequest, onCreateAndSendRequest } = this.props;
    
    dispatch<any>(ModalsActions.showModal(`MKS_SEND_REQUEST_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'mks.saveRequestConfirmation',
        successMessageKey: 'mks.saveRequestConfirmationMessage',
        confirmMessageKey: 'mks.saveRequestConfirmationConfirm',
        cancelMessageKey: 'mks.saveRequestConfirmationCancel',
        onConfirm: async () => {
          dispatch<any>(ModalsActions.hideModal(`MKS_SEND_REQUEST_CONFIRM_MODAL`));
          if (onCreateAndSendRequest) {
            await onCreateAndSendRequest(request);
          }
        },
        onCancel: () => {
          dispatch<any>(ModalsActions.hideModal(`MKS_SEND_REQUEST_CONFIRM_MODAL`));
          onCreateEditMKSRequest(request);
        },
      }
    }));
  }

  validateQuantities = () => {
    const { request, data, quantityErrors } = this.state;
    const newQuantityErrors: Record<number, boolean> = {};
    
    if (request.requestType === MKSRequestTypeOptions.KEY_DUPLICATION && data.keysDuplicates) {
      try {
        const duplicatesArray = JSON.parse(data.keysDuplicates);
        if (Array.isArray(duplicatesArray)) {
          duplicatesArray.forEach((dup: IMKSRequestDataKeyDuplicate, index: number) => {
            if (!dup || !dup.key || !dup.key.id || !dup.quantity || dup.quantity <= 0 || !Number.isInteger(dup.quantity)) {
              newQuantityErrors[index] = true;
            }
          });
        }
      } catch (e) {
        // Ignora errori di parsing
      }
    } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_DUPLICATION && data.cylindersDuplicates) {
      try {
        const duplicatesArray = JSON.parse(data.cylindersDuplicates);
        if (Array.isArray(duplicatesArray)) {
          duplicatesArray.forEach((dup: IMKSRequestDataCylinderDuplicate, index: number) => {
            if (!dup || !dup.cylinder || !dup.cylinder.id || !dup.quantity || dup.quantity <= 0 || !Number.isInteger(dup.quantity)) {
              newQuantityErrors[index] = true;
            }
          });
        }
      } catch (e) {
        // Ignora errori di parsing
      }
    }
    
    // Aggiorna solo se ci sono cambiamenti
    if (JSON.stringify(newQuantityErrors) !== JSON.stringify(quantityErrors)) {
      this.setState({ quantityErrors: newQuantityErrors });
    }
  };

  canSubmitForm() {
    const { request, data, quantityErrors } = this.state;
    const { request: editRequest } = this.props;
    
    // Validazione base
    if (editRequest) {
      // In edit mode, requestType is required
      if (!request.requestType) return false;
    } else {
      // In create mode, requestType and plantId are required
      if (!request.requestType || !(request as IMKSRequestInDTO).plantId) return false;
    }
    
    // Controlla se ci sono errori di quantità
    if (Object.keys(quantityErrors).length > 0) {
      return false;
    }
    
    // Validazione specifica per tipo di richiesta (solo per creazione o DRAFT)
    if (!editRequest || (editRequest && this.props.request?.status === MKSRequestStatusOptions.DRAFT)) {
      switch (request.requestType) {
        case MKSRequestTypeOptions.KEY_DUPLICATION:
          // Valida nuovo formato (array) o vecchio formato (retrocompatibilità)
          if (data.keysDuplicates) {
            try {
              const duplicatesArray = JSON.parse(data.keysDuplicates);
              return Array.isArray(duplicatesArray) && duplicatesArray.length > 0 && 
                     duplicatesArray.every((dup: IMKSRequestDataKeyDuplicate) => 
                       dup && dup.key && dup.key.id && dup.quantity && dup.quantity > 0 && Number.isInteger(dup.quantity)
                     );
            } catch (e) {
              return false;
            }
          }
          // Retrocompatibilità: vecchio formato
          return data.key && data.quantity;
        case MKSRequestTypeOptions.CYLINDER_DUPLICATION:
          // Valida nuovo formato (array) o vecchio formato (retrocompatibilità)
          if (data.cylindersDuplicates) {
            try {
              const duplicatesArray = JSON.parse(data.cylindersDuplicates);
              return Array.isArray(duplicatesArray) && duplicatesArray.length > 0 && 
                     duplicatesArray.every((dup: IMKSRequestDataCylinderDuplicate) => 
                       dup && dup.cylinder && dup.cylinder.id && dup.quantity && dup.quantity > 0 && Number.isInteger(dup.quantity)
                     );
            } catch (e) {
              return false;
            }
          }
          // Retrocompatibilità: vecchio formato
          return data.cylinder && data.quantity;
        case MKSRequestTypeOptions.KEY_EXTENSION:
          return data.cylinders && JSON.parse(data.cylinders || '[]').length > 0;
        case MKSRequestTypeOptions.CYLINDER_EXTENSION:
          return data.keys && JSON.parse(data.keys || '[]').length > 0;
        default:
          return true;
      }
    }
    
    return true;
  }

  onOpenRequestHistory(request: IMKSRequestDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`MKS_REQUEST_HISTORY_VIEW`, {
      modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
      modalProps: {
        content: (
          <MKSRequestHistoryList
            history={request.history}
          />
        ),
        titleMessageKey: 'mks.requestHistory',
      }
    }));
  }

  loadJsPDF = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      if ((window as any).jspdf) {
        resolve((window as any).jspdf);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      script.onload = () => {
        if ((window as any).jspdf) {
          resolve((window as any).jspdf);
        } else {
          reject(new Error('jsPDF failed to load'));
        }
      };
      script.onerror = () => reject(new Error('Failed to load jsPDF'));
      document.head.appendChild(script);
    });
  }

  generatePDF = async () => {
    const { request } = this.props;
    if (!request) return;

    try {
      const jspdf = await this.loadJsPDF();
      const { jsPDF } = jspdf;
      const pdf = new jsPDF();

      let yPosition = 20;
      const lineHeight = 7;
      const margin = 20;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const maxWidth = pageWidth - 2 * margin;

      // Helper per convertire hex a RGB
      const hexToRgb = (hex: string) => {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : { r: 0, g: 0, b: 0 };
      };

      // Helper per aggiungere testo con wrap
      const addText = (text: string, fontSize: number = 10, isBold: boolean = false, color: string = '#000000') => {
        pdf.setFontSize(fontSize);
        pdf.setFont('helvetica', isBold ? 'bold' : 'normal');
        const rgb = hexToRgb(color);
        pdf.setTextColor(rgb.r, rgb.g, rgb.b);
        const lines = pdf.splitTextToSize(text, maxWidth);
        lines.forEach((line: string) => {
          if (yPosition > 280) {
            pdf.addPage();
            yPosition = 20;
          }
          pdf.text(line, margin, yPosition);
          yPosition += lineHeight;
        });
        yPosition += 2;
      };

      // Titolo
      addText(translations.t('mks.requestManagement'), 18, true, '#000000');
      yPosition += 5;

      // Informazioni base
      addText(`${translations.t('mks.requestType')}: ${getRequestTypeOptions().find(e => e.value === request.requestType)?.label || '-'}`, 12, true);
      addText(`${translations.t('mks.requestStatus')}: ${translations.t(`mks.requestStatus_${request.status}`)}`, 12, true);
      
      if (request.customerName) {
        addText(`${translations.t('mks.customerName')}: ${request.customerName}`, 12);
      }
      
      if (request.varName) {
        addText(`${translations.t('mks.varName')}: ${request.varName}`, 12);
      }
      
      if (request.plantHostname) {
        addText(`${translations.t('mks.plantHostname')}: ${request.plantHostname}`, 12);
      }

      if (request.deliveryDate) {
        addText(`${translations.t('mks.deliveryDate')}: ${moment(request.deliveryDate).format('LL')}`, 12);
      }

      yPosition += 5;

      // Dati specifici della richiesta
      if (request.data) {
        const data = request.data;
        
        if (request.requestType === MKSRequestTypeOptions.KEY_DUPLICATION && data.keysDuplicates) {
          try {
            const duplicatesArray = JSON.parse(data.keysDuplicates);
            if (Array.isArray(duplicatesArray) && duplicatesArray.length > 0) {
              addText(translations.t('mks.keysDuplicates'), 14, true);
              duplicatesArray.forEach((dup: IMKSRequestDataKeyDuplicate, index: number) => {
                if (dup && dup.key) {
                  addText(`${translations.t('mks.duplicateEntry')} ${index + 1}:`, 11, true);
                  addText(`  ${translations.t('mks.selectKey')}: [${dup.key.externalId}] ${dup.key.keyFunction} - ${dup.key.designation}`, 10);
                  addText(`  ${translations.t('mks.quantity')}: ${dup.quantity}`, 10);
                  yPosition += 2;
                }
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_DUPLICATION && data.cylindersDuplicates) {
          try {
            const duplicatesArray = JSON.parse(data.cylindersDuplicates);
            if (Array.isArray(duplicatesArray) && duplicatesArray.length > 0) {
              addText(translations.t('mks.cylindersDuplicates'), 14, true);
              duplicatesArray.forEach((dup: IMKSRequestDataCylinderDuplicate, index: number) => {
                if (dup && dup.cylinder) {
                  addText(`${translations.t('mks.duplicateEntry')} ${index + 1}:`, 11, true);
                  addText(`  ${translations.t('mks.selectCylinder')}: [${dup.cylinder.externalId}] ${dup.cylinder.doorName} - ${dup.cylinder.marking} (${dup.cylinder.type})`, 10);
                  addText(`  ${translations.t('mks.quantity')}: ${dup.quantity}`, 10);
                  yPosition += 2;
                }
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.KEY_EXTENSION && data.cylinders) {
          try {
            const cylindersArray = JSON.parse(data.cylinders);
            if (Array.isArray(cylindersArray) && cylindersArray.length > 0) {
              addText(translations.t('mks.cylindersList'), 14, true);
              cylindersArray.forEach((cylinder: ICylinderInDTO, index: number) => {
                addText(`  ${index + 1}. [${cylinder.externalId}] ${cylinder.doorName} - ${cylinder.marking} (${cylinder.type})`, 10);
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_EXTENSION && data.keys) {
          try {
            const keysArray = JSON.parse(data.keys);
            if (Array.isArray(keysArray) && keysArray.length > 0) {
              addText(translations.t('mks.selectedKeys'), 14, true);
              keysArray.forEach((key: IKeyInDTO, index: number) => {
                addText(`  ${index + 1}. [${key.externalId}] ${key.keyFunction} - ${key.designation}`, 10);
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        }
      }

      yPosition += 5;

      // Note
      if (request.notes) {
        addText(translations.t('mks.requestNotes'), 14, true);
        addText(request.notes, 10);
      }

      // Note di rifiuto
      if (request.data && request.data.rejectedNotes) {
        yPosition += 5;
        addText(translations.t('mks.rejectedNotes'), 14, true);
        addText(request.data.rejectedNotes, 10);
      }

      // Genera blob URL
      let pdfBlob: Blob;
      try {
        // Prova prima con output('blob') se disponibile
        if (typeof pdf.output === 'function') {
          try {
            pdfBlob = pdf.output('blob');
          } catch (e) {
            // Se non supportato, usa datauristring
            const pdfDataUri = pdf.output('datauristring');
            const byteCharacters = atob(pdfDataUri.split(',')[1]);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
          }
        } else {
          // Fallback: usa datauristring
          const pdfDataUri = pdf.output('datauristring');
          const byteCharacters = atob(pdfDataUri.split(',')[1]);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
        }
      } catch (e) {
        // Ultimo fallback: usa datauristring
        const pdfDataUri = pdf.output('datauristring');
        const byteCharacters = atob(pdfDataUri.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
      }
      const blobUrl = URL.createObjectURL(pdfBlob);
      
      this.setState({
        pdfDialogOpen: true,
        pdfBlobUrl: blobUrl
      });
    } catch (error) {
      console.error('Error generating PDF:', error);
      const { dispatch } = this.props;
      dispatch<any>(ModalsActions.showModal(`MKS_PDF_GENERATION_ERROR_MODAL`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'mks.pdfGenerationError',
        }
      }));
    }
  }

  closePdfDialog = () => {
    const { pdfBlobUrl } = this.state;
    if (pdfBlobUrl) {
      URL.revokeObjectURL(pdfBlobUrl);
    }
    this.setState({
      pdfDialogOpen: false,
      pdfBlobUrl: null
    });
  }

  handleExportMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ exportMenuAnchorEl: event.currentTarget });
  }

  handleExportMenuClose = () => {
    this.setState({ exportMenuAnchorEl: null });
  }

  handleGeneratePDF = () => {
    this.handleExportMenuClose();
    this.generatePDF();
  }

  handleGenerateXLSX = () => {
    this.handleExportMenuClose();
    this.generateXLSX();
  }

  handleGenerateDOCX = () => {
    this.handleExportMenuClose();
    this.generateDOCX();
  }

  generateXLSX = () => {
    const { request } = this.props;
    if (!request) return;

    try {
      const exportData: any[] = [];
      
      const fieldLabel = translations.t('mks.field');
      const valueLabel = translations.t('mks.value');
      
      // Informazioni base in formato chiave-valore
      exportData.push({
        [fieldLabel]: translations.t('mks.requestType'),
        [valueLabel]: getRequestTypeOptions().find(e => e.value === request.requestType)?.label || '-',
      });
      exportData.push({
        [fieldLabel]: translations.t('mks.requestStatus'),
        [valueLabel]: translations.t(`mks.requestStatus_${request.status}`),
      });
      if (request.customerName) {
        exportData.push({
          [fieldLabel]: translations.t('mks.customerName'),
          [valueLabel]: request.customerName,
        });
      }
      if (request.varName) {
        exportData.push({
          [fieldLabel]: translations.t('mks.varName'),
          [valueLabel]: request.varName,
        });
      }
      if (request.plantHostname) {
        exportData.push({
          [fieldLabel]: translations.t('mks.plantHostname'),
          [valueLabel]: request.plantHostname,
        });
      }
      if (request.deliveryDate) {
        exportData.push({
          [fieldLabel]: translations.t('mks.deliveryDate'),
          [valueLabel]: moment(request.deliveryDate).format('LL'),
        });
      }

      // Dati specifici della richiesta
      if (request.data) {
        const data = request.data;
        
        if (request.requestType === MKSRequestTypeOptions.KEY_DUPLICATION && data.keysDuplicates) {
          try {
            const duplicatesArray = JSON.parse(data.keysDuplicates);
            if (Array.isArray(duplicatesArray) && duplicatesArray.length > 0) {
              exportData.push({ [fieldLabel]: '', [valueLabel]: '' });
              exportData.push({
                [fieldLabel]: translations.t('mks.keysDuplicates'),
                [valueLabel]: '',
              });
              duplicatesArray.forEach((dup: IMKSRequestDataKeyDuplicate, index: number) => {
                if (dup && dup.key) {
                  exportData.push({
                    [fieldLabel]: `${translations.t('mks.duplicateEntry')} ${index + 1}`,
                    [valueLabel]: `[${dup.key.externalId}] ${dup.key.keyFunction} - ${dup.key.designation} | ${translations.t('mks.quantity')}: ${dup.quantity}`,
                  });
                }
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_DUPLICATION && data.cylindersDuplicates) {
          try {
            const duplicatesArray = JSON.parse(data.cylindersDuplicates);
            if (Array.isArray(duplicatesArray) && duplicatesArray.length > 0) {
              exportData.push({ [fieldLabel]: '', [valueLabel]: '' });
              exportData.push({
                [fieldLabel]: translations.t('mks.cylindersDuplicates'),
                [valueLabel]: '',
              });
              duplicatesArray.forEach((dup: IMKSRequestDataCylinderDuplicate, index: number) => {
                if (dup && dup.cylinder) {
                  exportData.push({
                    [fieldLabel]: `${translations.t('mks.duplicateEntry')} ${index + 1}`,
                    [valueLabel]: `[${dup.cylinder.externalId}] ${dup.cylinder.doorName} - ${dup.cylinder.marking} (${dup.cylinder.type}) | ${translations.t('mks.quantity')}: ${dup.quantity}`,
                  });
                }
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.KEY_EXTENSION && data.cylinders) {
          try {
            const cylindersArray = JSON.parse(data.cylinders);
            if (Array.isArray(cylindersArray) && cylindersArray.length > 0) {
              exportData.push({ [fieldLabel]: '', [valueLabel]: '' });
              exportData.push({
                [fieldLabel]: translations.t('mks.cylindersList'),
                [valueLabel]: '',
              });
              cylindersArray.forEach((cylinder: ICylinderInDTO, index: number) => {
                exportData.push({
                  [fieldLabel]: `${index + 1}`,
                  [valueLabel]: `[${cylinder.externalId}] ${cylinder.doorName} - ${cylinder.marking} (${cylinder.type})`,
                });
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_EXTENSION && data.keys) {
          try {
            const keysArray = JSON.parse(data.keys);
            if (Array.isArray(keysArray) && keysArray.length > 0) {
              exportData.push({ [fieldLabel]: '', [valueLabel]: '' });
              exportData.push({
                [fieldLabel]: translations.t('mks.selectedKeys'),
                [valueLabel]: '',
              });
              keysArray.forEach((key: IKeyInDTO, index: number) => {
                exportData.push({
                  [fieldLabel]: `${index + 1}`,
                  [valueLabel]: `[${key.externalId}] ${key.keyFunction} - ${key.designation}`,
                });
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        }

        // Note
        if (request.notes) {
          exportData.push({ [fieldLabel]: '', [valueLabel]: '' });
          exportData.push({
            [fieldLabel]: translations.t('mks.requestNotes'),
            [valueLabel]: request.notes,
          });
        }

        // Note di rifiuto
        if (data.rejectedNotes) {
          exportData.push({ [fieldLabel]: '', [valueLabel]: '' });
          exportData.push({
            [fieldLabel]: translations.t('mks.rejectedNotes'),
            [valueLabel]: data.rejectedNotes,
          });
        }
      }

      const fileName = `MKS_Request_${request.id || 'new'}_${moment().format('YYYY-MM-DD')}`;
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = `.xlsx`;
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = { Sheets: { 'Request': ws }, SheetNames: ['Request'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (error) {
      console.error('Error generating XLSX:', error);
      const { dispatch } = this.props;
      dispatch<any>(ModalsActions.showModal(`MKS_XLSX_GENERATION_ERROR_MODAL`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'mks.xlsxGenerationError',
        }
      }));
    }
  }

  loadDocx = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      if ((window as any).docx) {
        resolve((window as any).docx);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/docx@7.8.2/build/index.js';
      script.onload = () => {
        if ((window as any).docx) {
          resolve((window as any).docx);
        } else {
          reject(new Error('docx failed to load'));
        }
      };
      script.onerror = () => reject(new Error('Failed to load docx'));
      document.head.appendChild(script);
    });
  }

  generateDOCX = async () => {
    const { request } = this.props;
    if (!request) return;

    try {
      const docxLib = await this.loadDocx();
      const { Document, Packer, Paragraph, TextRun, HeadingLevel, AlignmentType } = docxLib;

      const children: any[] = [];

      // Titolo
      children.push(new Paragraph({
        text: translations.t('mks.requestManagement'),
        heading: HeadingLevel.HEADING_1,
        alignment: AlignmentType.CENTER,
      }));

      children.push(new Paragraph({ text: '' }));

      // Informazioni base
      children.push(new Paragraph({
        text: translations.t('mks.requestType'),
        heading: HeadingLevel.HEADING_2,
      }));
      children.push(new Paragraph({
        text: getRequestTypeOptions().find(e => e.value === request.requestType)?.label || '-',
      }));

      children.push(new Paragraph({
        text: translations.t('mks.requestStatus'),
        heading: HeadingLevel.HEADING_2,
      }));
      children.push(new Paragraph({
        text: translations.t(`mks.requestStatus_${request.status}`),
      }));

      if (request.customerName) {
        children.push(new Paragraph({
          text: translations.t('mks.customerName'),
          heading: HeadingLevel.HEADING_2,
        }));
        children.push(new Paragraph({ text: request.customerName }));
      }

      if (request.varName) {
        children.push(new Paragraph({
          text: translations.t('mks.varName'),
          heading: HeadingLevel.HEADING_2,
        }));
        children.push(new Paragraph({ text: request.varName }));
      }

      if (request.plantHostname) {
        children.push(new Paragraph({
          text: translations.t('mks.plantHostname'),
          heading: HeadingLevel.HEADING_2,
        }));
        children.push(new Paragraph({ text: request.plantHostname }));
      }

      if (request.deliveryDate) {
        children.push(new Paragraph({
          text: translations.t('mks.deliveryDate'),
          heading: HeadingLevel.HEADING_2,
        }));
        children.push(new Paragraph({ text: moment(request.deliveryDate).format('LL') }));
      }

      // Dati specifici della richiesta
      if (request.data) {
        const data = request.data;
        
        if (request.requestType === MKSRequestTypeOptions.KEY_DUPLICATION && data.keysDuplicates) {
          try {
            const duplicatesArray = JSON.parse(data.keysDuplicates);
            if (Array.isArray(duplicatesArray) && duplicatesArray.length > 0) {
              children.push(new Paragraph({ text: '' }));
              children.push(new Paragraph({
                text: translations.t('mks.keysDuplicates'),
                heading: HeadingLevel.HEADING_2,
              }));
              duplicatesArray.forEach((dup: IMKSRequestDataKeyDuplicate, index: number) => {
                if (dup && dup.key) {
                  children.push(new Paragraph({
                    text: `${translations.t('mks.duplicateEntry')} ${index + 1}:`,
                    heading: HeadingLevel.HEADING_3,
                  }));
                  children.push(new Paragraph({
                    text: `${translations.t('mks.selectKey')}: [${dup.key.externalId}] ${dup.key.keyFunction} - ${dup.key.designation}`,
                  }));
                  children.push(new Paragraph({
                    text: `${translations.t('mks.quantity')}: ${dup.quantity}`,
                  }));
                  children.push(new Paragraph({ text: '' }));
                }
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_DUPLICATION && data.cylindersDuplicates) {
          try {
            const duplicatesArray = JSON.parse(data.cylindersDuplicates);
            if (Array.isArray(duplicatesArray) && duplicatesArray.length > 0) {
              children.push(new Paragraph({ text: '' }));
              children.push(new Paragraph({
                text: translations.t('mks.cylindersDuplicates'),
                heading: HeadingLevel.HEADING_2,
              }));
              duplicatesArray.forEach((dup: IMKSRequestDataCylinderDuplicate, index: number) => {
                if (dup && dup.cylinder) {
                  children.push(new Paragraph({
                    text: `${translations.t('mks.duplicateEntry')} ${index + 1}:`,
                    heading: HeadingLevel.HEADING_3,
                  }));
                  children.push(new Paragraph({
                    text: `${translations.t('mks.selectCylinder')}: [${dup.cylinder.externalId}] ${dup.cylinder.doorName} - ${dup.cylinder.marking} (${dup.cylinder.type})`,
                  }));
                  children.push(new Paragraph({
                    text: `${translations.t('mks.quantity')}: ${dup.quantity}`,
                  }));
                  children.push(new Paragraph({ text: '' }));
                }
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.KEY_EXTENSION && data.cylinders) {
          try {
            const cylindersArray = JSON.parse(data.cylinders);
            if (Array.isArray(cylindersArray) && cylindersArray.length > 0) {
              children.push(new Paragraph({ text: '' }));
              children.push(new Paragraph({
                text: translations.t('mks.cylindersList'),
                heading: HeadingLevel.HEADING_2,
              }));
              cylindersArray.forEach((cylinder: ICylinderInDTO, index: number) => {
                children.push(new Paragraph({
                  text: `${index + 1}. [${cylinder.externalId}] ${cylinder.doorName} - ${cylinder.marking} (${cylinder.type})`,
                }));
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        } else if (request.requestType === MKSRequestTypeOptions.CYLINDER_EXTENSION && data.keys) {
          try {
            const keysArray = JSON.parse(data.keys);
            if (Array.isArray(keysArray) && keysArray.length > 0) {
              children.push(new Paragraph({ text: '' }));
              children.push(new Paragraph({
                text: translations.t('mks.selectedKeys'),
                heading: HeadingLevel.HEADING_2,
              }));
              keysArray.forEach((key: IKeyInDTO, index: number) => {
                children.push(new Paragraph({
                  text: `${index + 1}. [${key.externalId}] ${key.keyFunction} - ${key.designation}`,
                }));
              });
            }
          } catch (e) {
            // Ignora errori di parsing
          }
        }

        // Note
        if (request.notes) {
          children.push(new Paragraph({ text: '' }));
          children.push(new Paragraph({
            text: translations.t('mks.requestNotes'),
            heading: HeadingLevel.HEADING_2,
          }));
          children.push(new Paragraph({ text: request.notes }));
        }

        // Note di rifiuto
        if (data.rejectedNotes) {
          children.push(new Paragraph({ text: '' }));
          children.push(new Paragraph({
            text: translations.t('mks.rejectedNotes'),
            heading: HeadingLevel.HEADING_2,
          }));
          children.push(new Paragraph({ text: data.rejectedNotes }));
        }
      }

      const doc = new Document({
        sections: [{
          children: children,
        }],
      });

      const blob = await Packer.toBlob(doc);
      const fileName = `MKS_Request_${request.id || 'new'}_${moment().format('YYYY-MM-DD')}.docx`;
      FileSaver.saveAs(blob, fileName);
    } catch (error) {
      console.error('Error generating DOCX:', error);
      const { dispatch } = this.props;
      dispatch<any>(ModalsActions.showModal(`MKS_DOCX_GENERATION_ERROR_MODAL`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'mks.docxGenerationError',
        }
      }));
    }
  }

  onKeyClick = async (keyData: IKeyInDTO) => {
    const { dispatch } = this.props;
    dispatch<any>(MksActions.setSelectedKey(keyData));
    dispatch<any>(ModalsActions.showModal(`MKS_KEY_DETAILS_MODAL`, {
      modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
      modalProps: {
        content: <MksKeyForm keyData={keyData} hideDuplicateButton={true} receivedHostnameFromMksRequestForm={this.props.request?.plantHostname} />,
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`MKS_KEY_DETAILS_MODAL`)),
      }
    }));
  }

  onCylinderClick = async (cylinderData: ICylinderInDTO) => {
    const { dispatch } = this.props;
    dispatch<any>(MksActions.setSelectedCylinder(cylinderData));
    dispatch<any>(ModalsActions.showModal(`MKS_CYLINDER_DETAILS_MODAL`, {
      modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
      modalProps: {
        content: <MksCylinderForm cylinderData={cylinderData} hideDuplicateButton={true} receivedHostnameFromMksRequestForm={this.props.request?.plantHostname}/>,
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`MKS_CYLINDER_DETAILS_MODAL`)),
      }
    }));
  }

  renderDuplicateKeyFields(canEdit: boolean, isDisabled?: boolean) {
    const { data } = this.state;
    const { keys } = this.props;
    
    const availableKeys = keys && keys.content ? keys.content : [];
    const isEdit = Boolean(this.props.request) && this.props.request?.status !== MKSRequestStatusOptions.DRAFT;
    
    // Carica array di duplicati o usa array vuoto
    let duplicatesArray: IMKSRequestDataKeyDuplicate[] = [];
    try {
      if (data.keysDuplicates) {
        duplicatesArray = JSON.parse(data.keysDuplicates);
      }
    } catch (e) {
      duplicatesArray = [];
    }
    
    const addDuplicate = () => {
      const newDuplicates = [...duplicatesArray, { key: null as any, quantity: 1 }];
      this.onChangeData('keysDuplicates', JSON.stringify(newDuplicates));
    };
    
    const removeDuplicate = (index: number) => {
      const newDuplicates = duplicatesArray.filter((_, i) => i !== index);
      this.onChangeData('keysDuplicates', JSON.stringify(newDuplicates));
    };
    
    const updateDuplicateKey = (index: number, key: IKeyInDTO | IMKSRequestDataKey | null) => {
      const newDuplicates = [...duplicatesArray];
      if (key) {
        const convertedKey: IMKSRequestDataKey = {
          id: key.id,
          externalId: key.externalId,
          keyFunction: key.keyFunction || '',
          designation: key.designation || ''
        };
        newDuplicates[index] = { ...newDuplicates[index], key: convertedKey };
      } else {
        newDuplicates[index] = { ...newDuplicates[index], key: null as any };
      }
      this.onChangeData('keysDuplicates', JSON.stringify(newDuplicates));
    };
    
    const updateDuplicateQuantity = (index: number, quantity: string) => {
      const newDuplicates = [...duplicatesArray];
      // Permetti valore vuoto, non convertire automaticamente
      const parsedQuantity = quantity === '' ? undefined : parseInt(quantity);
      newDuplicates[index] = { ...newDuplicates[index], quantity: parsedQuantity !== undefined && !isNaN(parsedQuantity) ? parsedQuantity : undefined as any };
      this.onChangeData('keysDuplicates', JSON.stringify(newDuplicates));
    };
    
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <h4 style={{ fontWeight: 'bold', margin: 0 }}>
            <ReduxLanguage languageKey={'mks.keysDuplicates'} /><span style={{ color: 'red' }}>*</span>
          </h4>
          {canEdit && !isDisabled && (
            <Button
              variant="contained"
              style={{ backgroundColor: '#5AC0B1', color: 'white', minWidth: 'auto', padding: '8px 16px' }}
              onClick={addDuplicate}
            >
              <AddIcon style={{ fontSize: 18, marginRight: 5 }} />
              <ReduxLanguage languageKey={'mks.addKey'} />
            </Button>
          )}
        </div>
        
        {duplicatesArray.length === 0 && !canEdit ? (
          <div style={{ 
            padding: '12px 16px', 
            border: '1px solid #e0e0e0', 
            borderRadius: '4px', 
            backgroundColor: '#f9f9f9',
            fontSize: '16px',
            color: '#999',
            fontStyle: 'italic'
          }}>
            {translations.t('mks.noKeysSelected')}
          </div>
        ) : (
          duplicatesArray.map((duplicate, index) => {
            let selectedKey: IKeyInDTO | IMKSRequestDataKey | null = null;
            try {
              if (duplicate.key) {
                // Se è IMKSRequestDataKey dal backend, cerca la chiave corrispondente nella lista disponibile
                if (duplicate.key.id && availableKeys.length > 0) {
                  const matchingKey = availableKeys.find((k: IKeyInDTO) => k.id === duplicate.key.id || k.externalId === duplicate.key.externalId);
                  selectedKey = matchingKey || duplicate.key;
                } else {
                  selectedKey = duplicate.key;
                }
              }
            } catch (e) {
              selectedKey = null;
            }
            
            return (
              <Card key={index} style={{ padding: 15, marginTop: 10, display: 'flex', flexDirection: 'column', gap: 15 }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                  <h5 style={{ margin: 0, fontWeight: 'bold' }}>
                    <ReduxLanguage languageKey={'mks.duplicateKey'} /> {index + 1}
                  </h5>
                  {canEdit && !isDisabled && duplicatesArray.length > 1 && (
                    <Button
                      variant="contained"
                      style={{ backgroundColor: '#d32f2f', color: 'white', minWidth: 'auto', padding: '4px 12px' }}
                      onClick={() => removeDuplicate(index)}
                    >
                      <DeleteIcon style={{ fontSize: 18 }} />
                    </Button>
                  )}
                </div>
                
                {canEdit ? (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 15, alignItems: 'flex-start' }}>
                      <div style={{ flex: 1 }}>
                        <Autocomplete
                          id={`key-selection-${index}`}
                          options={availableKeys}
                          disabled={isDisabled}
                          getOptionLabel={(option: IKeyInDTO | IMKSRequestDataKey) => `[${option.externalId}] ${option.keyFunction} - ${option.designation}`}
                          getOptionSelected={(option, value) => option.id === value.id}
                          value={selectedKey}
                          onChange={(event, newValue) => {
                            updateDuplicateKey(index, (newValue && typeof newValue === 'object' && 'id' in newValue) ? newValue : null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              required={true}
                              variant="outlined"
                              label={translations.t('mks.selectKey')}
                              placeholder={translations.t('mks.selectKey')}
                            />
                          )}
                        />
                      </div>
                      <div style={{ width: 150 }}>
                        <TextField
                          id={`quantity-${index}`}
                          label={<><ReduxLanguage languageKey={'mks.quantity'} /><span style={{ color: 'red' }}>*</span></>}
                          variant="outlined"
                          type="number"
                          value={duplicate.quantity === undefined || duplicate.quantity === null ? '' : duplicate.quantity}
                          disabled={isDisabled}
                          error={this.state.quantityErrors[index] || false}
                          helperText={this.state.quantityErrors[index] ? translations.t('mks.quantityError') : ''}
                          onChange={e => {
                            const value = e.target.value;
                            updateDuplicateQuantity(index, value);
                            // Rimuovi l'errore quando l'utente modifica
                            if (this.state.quantityErrors[index]) {
                              this.setState({
                                quantityErrors: { ...this.state.quantityErrors, [index]: false }
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 15, alignItems: 'end' }}>
                      <div style={{ flex: 1 }}>
                        {selectedKey ? (
                          <div 
                            onClick={() => {
                              if ('id' in selectedKey && selectedKey.id) {
                                const fullKey = availableKeys.find((k: IKeyInDTO) => k.id === selectedKey.id);
                                if (fullKey) {
                                  this.onKeyClick(fullKey);
                                }
                              }
                            }}
                            style={{ 
                              padding: '8px 12px', 
                              paddingLeft: 16,
                              margin: '0px 0',
                              border: '1px solid #e0e0e0', 
                              borderRadius: '4px', 
                              backgroundColor: 'white',
                              fontSize: '15px',
                              color: '#333',
                              cursor: 'pointer',
                              transition: 'background-color 0.2s',
                              display: 'flex',
                              alignItems: 'center',
                              height: 28
                            }}
                            onMouseEnter={(e) => {
                              if ('id' in selectedKey && selectedKey.id && availableKeys.find((k: IKeyInDTO) => k.id === selectedKey.id)) {
                                e.currentTarget.style.backgroundColor = '#f0f0f0';
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'white';
                            }}
                          >
                            [{selectedKey.externalId}] {selectedKey.keyFunction} - {selectedKey.designation}
                          </div>
                        ) : (
                          <div style={{ 
                            padding: '12px 16px', 
                            border: '1px solid #e0e0e0', 
                            borderRadius: '4px', 
                            backgroundColor: '#f9f9f9',
                            fontSize: '16px',
                            color: '#999',
                            fontStyle: 'italic'
                          }}>
                            {translations.t('mks.noKeySelected')}
                          </div>
                        )}
                      </div>
                      <div style={{ width: 150 }}>
                        <h4 style={{ margin: 0, marginBottom: 5, fontWeight: 'bold' }}>
                          <ReduxLanguage languageKey={'mks.quantity'} />
                        </h4>
                        <div style={{ 
                          padding: '12px 16px', 
                          border: '1px solid #e0e0e0', 
                          borderRadius: '4px', 
                          backgroundColor: '#f9f9f9',
                          fontSize: '16px',
                          color: '#333'
                        }}>
                          {duplicate.quantity || '-'}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            );
          })
        )}
      </div>
    );
  }

  renderDuplicateCylinderFields(canEdit: boolean, isDisabled?: boolean) {
    const { data } = this.state;
    const { cylinders } = this.props;
    
    const availableCylinders = cylinders && cylinders.content ? cylinders.content : [];
    const isEdit = Boolean(this.props.request) && this.props.request?.status !== MKSRequestStatusOptions.DRAFT;
    
    // Carica array di duplicati o usa array vuoto
    let duplicatesArray: IMKSRequestDataCylinderDuplicate[] = [];
    try {
      if (data.cylindersDuplicates) {
        duplicatesArray = JSON.parse(data.cylindersDuplicates);
      }
    } catch (e) {
      duplicatesArray = [];
    }
    
    const addDuplicate = () => {
      const newDuplicates = [...duplicatesArray, { cylinder: null as any, quantity: 1 }];
      this.onChangeData('cylindersDuplicates', JSON.stringify(newDuplicates));
    };
    
    const removeDuplicate = (index: number) => {
      const newDuplicates = duplicatesArray.filter((_, i) => i !== index);
      this.onChangeData('cylindersDuplicates', JSON.stringify(newDuplicates));
    };
    
    const updateDuplicateCylinder = (index: number, cylinder: ICylinderInDTO | IMKSRequestDataCylinder | null) => {
      const newDuplicates = [...duplicatesArray];
      if (cylinder) {
        const convertedCylinder: IMKSRequestDataCylinder = {
          id: cylinder.id,
          externalId: cylinder.externalId,
          doorName: cylinder.doorName || '',
          marking: cylinder.marking || '',
          type: cylinder.type || ''
        };
        newDuplicates[index] = { ...newDuplicates[index], cylinder: convertedCylinder };
      } else {
        newDuplicates[index] = { ...newDuplicates[index], cylinder: null as any };
      }
      this.onChangeData('cylindersDuplicates', JSON.stringify(newDuplicates));
    };
    
    const updateDuplicateQuantity = (index: number, quantity: string) => {
      const newDuplicates = [...duplicatesArray];
      // Permetti valore vuoto, non convertire automaticamente
      const parsedQuantity = quantity === '' ? undefined : parseInt(quantity);
      newDuplicates[index] = { ...newDuplicates[index], quantity: parsedQuantity !== undefined && !isNaN(parsedQuantity) ? parsedQuantity : undefined as any };
      this.onChangeData('cylindersDuplicates', JSON.stringify(newDuplicates));
    };
    
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <h4 style={{ fontWeight: 'bold', margin: 0 }}>
            <ReduxLanguage languageKey={'mks.cylindersDuplicates'} /><span style={{ color: 'red' }}>*</span>
          </h4>
          {canEdit && !isDisabled && (
            <Button
              variant="contained"
              style={{ backgroundColor: '#5AC0B1', color: 'white', minWidth: 'auto', padding: '8px 16px' }}
              onClick={addDuplicate}
            >
              <AddIcon style={{ fontSize: 18, marginRight: 5 }} />
              <ReduxLanguage languageKey={'mks.addCylinder'} />
            </Button>
          )}
        </div>
        
        {duplicatesArray.length === 0 && !canEdit ? (
          <div style={{ 
            padding: '12px 16px', 
            border: '1px solid #e0e0e0', 
            borderRadius: '4px', 
            backgroundColor: '#f9f9f9',
            fontSize: '16px',
            color: '#999',
            fontStyle: 'italic'
          }}>
            {translations.t('mks.noCylindersSelected')}
          </div>
        ) : (
          duplicatesArray.map((duplicate, index) => {
            let selectedCylinder: ICylinderInDTO | IMKSRequestDataCylinder | null = null;
            try {
              if (duplicate.cylinder) {
                // Se è IMKSRequestDataCylinder dal backend, cerca il cilindro corrispondente nella lista disponibile
                if (duplicate.cylinder.id && availableCylinders.length > 0) {
                  const matchingCylinder = availableCylinders.find((c: ICylinderInDTO) => c.id === duplicate.cylinder.id || c.externalId === duplicate.cylinder.externalId);
                  selectedCylinder = matchingCylinder || duplicate.cylinder;
                } else {
                  selectedCylinder = duplicate.cylinder;
                }
              }
            } catch (e) {
              selectedCylinder = null;
            }
            
            return (
              <Card key={index} style={{ padding: 15, marginTop: 10, display: 'flex', flexDirection: 'column', gap: 15 }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                  <h5 style={{ margin: 0, fontWeight: 'bold' }}>
                    <ReduxLanguage languageKey={'mks.duplicateCylinder'} /> {index + 1}
                  </h5>
                  {canEdit && !isDisabled && duplicatesArray.length > 1 && (
                    <Button
                      variant="contained"
                      style={{ backgroundColor: '#d32f2f', color: 'white', minWidth: 'auto', padding: '4px 12px' }}
                      onClick={() => removeDuplicate(index)}
                    >
                      <DeleteIcon style={{ fontSize: 18 }} />
                    </Button>
                  )}
                </div>
                
                {canEdit ? (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 15, alignItems: 'flex-start' }}>
                      <div style={{ flex: 1 }}>
                        <Autocomplete
                          id={`cylinder-selection-${index}`}
                          options={availableCylinders}
                          disabled={isDisabled}
                          getOptionLabel={(option: ICylinderInDTO | IMKSRequestDataCylinder) => `[${option.externalId}] ${option.doorName} - ${option.marking} (${option.type})`}
                          getOptionSelected={(option, value) => option.id === value.id}
                          value={selectedCylinder}
                          onChange={(event, newValue) => {
                            updateDuplicateCylinder(index, (newValue && typeof newValue === 'object' && 'id' in newValue) ? newValue : null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              label={translations.t('mks.selectCylinder')}
                              placeholder={translations.t('mks.selectCylinder')}
                            />
                          )}
                        />
                      </div>
                      <div style={{ width: 150 }}>
                        <TextField
                          id={`quantity-${index}`}
                          label={<><ReduxLanguage languageKey={'mks.quantity'} /><span style={{ color: 'red' }}>*</span></>}
                          variant="outlined"
                          type="number"
                          value={duplicate.quantity === undefined || duplicate.quantity === null ? '' : duplicate.quantity}
                          disabled={isDisabled}
                          error={this.state.quantityErrors[index] || false}
                          helperText={this.state.quantityErrors[index] ? translations.t('mks.quantityError') : ''}
                          onChange={e => {
                            const value = e.target.value;
                            updateDuplicateQuantity(index, value);
                            // Rimuovi l'errore quando l'utente modifica
                            if (this.state.quantityErrors[index]) {
                              this.setState({
                                quantityErrors: { ...this.state.quantityErrors, [index]: false }
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 15, alignItems: 'end' }}>
                      <div style={{ flex: 1 }}>
                        {selectedCylinder ? (
                          <div 
                            onClick={() => {
                              if ('id' in selectedCylinder && selectedCylinder.id) {
                                const fullCylinder = availableCylinders.find((c: ICylinderInDTO) => c.id === selectedCylinder.id);
                                if (fullCylinder) {
                                  this.onCylinderClick(fullCylinder);
                                }
                              }
                            }}
                            style={{ 
                              padding: '8px 12px', 
                              paddingLeft: 16,
                              margin: '0px 0',
                              border: '1px solid #e0e0e0', 
                              borderRadius: '4px', 
                              backgroundColor: 'white',
                              fontSize: '15px',
                              color: '#333',
                              cursor: 'pointer',
                              transition: 'background-color 0.2s',
                              display: 'flex',
                              alignItems: 'center',
                              height: 28
                            }}
                            onMouseEnter={(e) => {
                              if ('id' in selectedCylinder && selectedCylinder.id && availableCylinders.find((c: ICylinderInDTO) => c.id === selectedCylinder.id)) {
                                e.currentTarget.style.backgroundColor = '#f0f0f0';
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'white';
                            }}
                          >
                            [{selectedCylinder.externalId}] {selectedCylinder.doorName} - {selectedCylinder.marking} ({selectedCylinder.type})
                          </div>
                        ) : (
                          <div style={{ 
                            padding: '12px 16px', 
                            border: '1px solid #e0e0e0', 
                            borderRadius: '4px', 
                            backgroundColor: '#f9f9f9',
                            fontSize: '16px',
                            color: '#999',
                            fontStyle: 'italic'
                          }}>
                            {translations.t('mks.noCylinderSelected')}
                          </div>
                        )}
                      </div>
                      <div style={{ width: 150 }}>
                        <h4 style={{ margin: 0, marginBottom: 5, fontWeight: 'bold' }}>
                          <ReduxLanguage languageKey={'mks.quantity'} />
                        </h4>
                        <div style={{ 
                          padding: '12px 16px', 
                          border: '1px solid #e0e0e0', 
                          borderRadius: '4px', 
                          backgroundColor: '#f9f9f9',
                          fontSize: '16px',
                          color: '#333'
                        }}>
                          {duplicate.quantity || '-'}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            );
          })
        )}
      </div>
    );
  }

  renderKeyExtensionFields(canEdit: boolean, cylinders: any, isDisabled?: boolean) {
    const { data } = this.state;
    const isEdit = Boolean(this.props.request) && this.props.request?.status !== MKSRequestStatusOptions.DRAFT;
    const availableCylinders = cylinders && cylinders.content ? cylinders.content : [];
    let selectedCylinders = [];
    try {
      selectedCylinders = data.cylinders ? JSON.parse(data.cylinders) : [];
    } catch (e) {
      selectedCylinders = [];
    }
    
    return (
      <div style={{ marginTop: 0 }}>
        {isEdit && !_.isEmpty(selectedCylinders) ? (
          <h4 style={{ fontWeight: 'bold', marginTop: 20, marginBottom: 10 }}>
            <ReduxLanguage languageKey={'mks.cylindersList'} /><span style={{ color: 'red' }}>*</span>
          </h4>
        ) : null}
        {canEdit ? (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 10, marginTop: 15 }}>
            <div style={{ flex: 1 }}>
              <Autocomplete
                id="cylinders-selection"
                disableCloseOnSelect
                options={availableCylinders}
                multiple
                disabled={isDisabled}
                getOptionLabel={(option: ICylinderInDTO) => `[${option.externalId || ""}] ${option.doorName || ""} - ${option.marking || ""} (${option.type || ""})`}
                value={selectedCylinders}
                onChange={(event, newValue) => {
                  // Mi assicuro di NON aggiungere doppioni!
                  let newArray = newValue || []
                  newArray = newArray.filter((item: ICylinderInDTO, index: number, self: ICylinderInDTO[]) =>
                    index === self.findIndex((t) => t.id === item.id)
                  );
                  this.onChangeData('cylinders', JSON.stringify(newArray));
                }}
                renderOption={(option: ICylinderInDTO, { selected }) => {
                  const isSelected = selectedCylinders.some((c: ICylinderInDTO) => c.id === option.id);
                  return (
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      width: '100%',
                      backgroundColor: isSelected ? 'rgba(100, 149, 237, 0.15)' : 'transparent',
                      padding: '8px 4px',
                      borderRadius: '4px'
                    }}>
                      <Checkbox color="primary" checked={isSelected} style={{ padding: '4px 8px' }} />
                      <span style={{ 
                        flex: 1, 
                        fontWeight: isSelected ? 'bold' : 'normal',
                        color: isSelected ? 'cornflowerblue' : 'inherit'
                      }}>
                        [{option.externalId || ""}] {option.doorName || ""} - {option.marking || ""} ({option.type || ""})
                      </span>
                    </div>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params} 
                    required={true}
                    variant="outlined"
                    label={translations.t('mks.selectCylinders')}
                    placeholder={translations.t('mks.selectCylinders')}
                  />
                )}
              />
            </div>
            <Button
              variant="contained"
              disabled={isDisabled}
              onClick={() => this.openBatchAddDialog('cylinders')}
              style={{ 
                backgroundColor: '#5AC0B1', 
                color: 'white', 
                minWidth: 'auto',
                padding: '10px 16px',
                marginTop: '0px',
                minHeight: '56px',
                maxWidth: '150px',
                whiteSpace: 'normal',
                lineHeight: '1.2'
              }}
            >
              <ReduxLanguage languageKey={'mks.openAdvancedSelector'} />
            </Button>
          </div>
        ) : (
          <div style={{ marginTop: 0 }}>
            {selectedCylinders.length > 0 ? (
              selectedCylinders.map((cylinder: ICylinderInDTO, index: number) => (
                <div 
                  key={index} 
                  onClick={() => this.onCylinderClick(cylinder)}
                  style={{ 
                    padding: '8px 12px', 
                    paddingLeft: 16,
                    margin: '4px 0',
                    border: '1px solid #e0e0e0', 
                    borderRadius: '4px', 
                    backgroundColor: 'white',
                    fontSize: '15px',
                    color: '#333',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    height: 28
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f0f0f0';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'white';
                  }}
                >
                  [{cylinder.externalId}] {cylinder.doorName} - {cylinder.marking} ({cylinder.type})
                </div>
              ))
            ) : (
              <div style={{ 
                padding: '12px 16px', 
                border: '1px solid #e0e0e0', 
                borderRadius: '4px', 
                backgroundColor: '#f9f9f9',
                fontSize: '16px',
                color: '#999',
                fontStyle: 'italic'
              }}>
                {translations.t('mks.noCylinderSelected')}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderCylinderExtensionFields(canEdit: boolean, keys: any, isDisabled?: boolean) {
    const { data } = this.state;
    const isEdit = Boolean(this.props.request) && this.props.request?.status !== MKSRequestStatusOptions.DRAFT;
    const availableKeys = keys && keys.content ? keys.content : [];
    let selectedKeys = [];
    try {
      selectedKeys = data.keys ? JSON.parse(data.keys) : [];
    } catch (e) {
      selectedKeys = [];
    }
    
    return (
      <div style={{ marginTop: 20 }}>
        {isEdit && !_.isEmpty(selectedKeys) ? (
          <h4 style={{ fontWeight: 'bold' }}>
            <ReduxLanguage languageKey={'mks.selectedKeys'} /><span style={{ color: 'red' }}>*</span>
          </h4>
        ) : null}
        {canEdit ? (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 10, marginTop: 10 }}>
            <div style={{ flex: 1 }}>
              <Autocomplete
                id="keys-selection"
                disableCloseOnSelect
                options={availableKeys}
                multiple
                disabled={isDisabled}
                getOptionLabel={(option: IKeyInDTO) => `[${option.externalId || ""}] ${option.keyFunction || ""} - ${option.designation || ""}`}
                value={selectedKeys}
                onChange={(event, newValue) => {
                  // Mi assicuro di NON aggiungere doppioni!
                  let newArray = newValue || []
                  newArray = newArray.filter((item: IKeyInDTO, index: number, self: IKeyInDTO[]) =>
                    index === self.findIndex((t) => t.id === item.id)
                  );
                  this.onChangeData('keys', JSON.stringify(newArray));
                }}
                renderOption={(option: IKeyInDTO, { selected }) => {
                  const isSelected = selectedKeys.some((k: IKeyInDTO) => k.id === option.id);
                  return (
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      width: '100%',
                      backgroundColor: isSelected ? 'rgba(100, 149, 237, 0.15)' : 'transparent',
                      padding: '8px 4px',
                      borderRadius: '4px'
                    }}>
                      <Checkbox color="primary" checked={isSelected} style={{ padding: '4px 8px' }} />
                      <span style={{ 
                        flex: 1, 
                        fontWeight: isSelected ? 'bold' : 'normal',
                        color: isSelected ? 'cornflowerblue' : 'inherit'
                      }}>
                        [{option.externalId || ""}] {option.keyFunction || ""} - {option.designation || ""}
                      </span>
                    </div>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required={true}
                    variant="outlined"
                    label={translations.t('mks.selectKeys')}
                    placeholder={translations.t('mks.selectKeys')}
                  />
                )}
              />
            </div>
            <Button
              variant="contained"
              disabled={isDisabled}
              onClick={() => this.openBatchAddDialog('keys')}
              style={{ 
                backgroundColor: '#5AC0B1', 
                color: 'white', 
                minWidth: 'auto',
                padding: '10px 16px',
                marginTop: '0px',
                minHeight: '56px',
                maxWidth: '150px',
                whiteSpace: 'normal',
                lineHeight: '1.2'
              }}
            >
              <ReduxLanguage languageKey={'mks.openAdvancedSelector'} />
            </Button>
          </div>
        ) : (
          <div style={{ marginTop: 10 }}>
            {selectedKeys.length > 0 ? (
              selectedKeys.map((key: IKeyInDTO, index: number) => (
                <div 
                  key={index} 
                  onClick={() => this.onKeyClick(key)}
                  style={{ 
                    padding: '8px 12px', 
                    paddingLeft: 16,
                    margin: '4px 0',
                    border: '1px solid #e0e0e0', 
                    borderRadius: '4px', 
                    backgroundColor: 'white',
                    fontSize: '15px',
                    color: '#333',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    height: 35
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f0f0f0';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'white';
                  }}
                >
                  [{key.externalId}] {key.keyFunction} - {key.designation}
                </div>
              ))
            ) : (
              <div style={{ 
                padding: '12px 16px', 
                border: '1px solid #e0e0e0', 
                borderRadius: '4px', 
                backgroundColor: '#f9f9f9',
                fontSize: '16px',
                color: '#999',
                fontStyle: 'italic'
              }}>
                {translations.t('mks.noKeySelected')}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  openBatchAddDialog = (type: 'cylinders' | 'keys') => {
    this.setState({ 
      batchAddDialogOpen: true, 
      batchAddDialogType: type,
      batchAddFilterInput: ''
    });
  }

  closeBatchAddDialog = () => {
    this.setState({ 
      batchAddDialogOpen: false, 
      batchAddDialogType: null,
      batchAddFilterInput: ''
    });
  }

  confirmBatchAdd = () => {
    const { batchAddDialogType, batchAddFilterInput, data } = this.state;
    const { keys, cylinders } = this.props;
    
    if (!batchAddDialogType) return;
    
    // Ottieni gli elementi disponibili in base al tipo
    const availableItems = batchAddDialogType === 'cylinders' 
      ? (cylinders && cylinders.content ? cylinders.content : [])
      : (keys && keys.content ? keys.content : []);
    
    // Filtra gli elementi in base all'input
    const filteredItems = batchAddFilterInput && batchAddFilterInput.trim().length > 0
      ? availableItems.filter((item: ICylinderInDTO | IKeyInDTO) => {
          const searchLower = batchAddFilterInput.toLowerCase();
          let label = '';
          if (batchAddDialogType === 'cylinders') {
            const cylinder = item as ICylinderInDTO;
            label = `[${cylinder.externalId || ""}] ${cylinder.doorName || ""} - ${cylinder.marking || ""} (${cylinder.type || ""})`.toLowerCase();
          } else {
            const key = item as IKeyInDTO;
            label = `[${key.externalId || ""}] ${key.keyFunction || ""} - ${key.designation || ""}`.toLowerCase();
          }
          return label.includes(searchLower);
        })
      : availableItems;
    
    // Limita a 50 elementi
    if (filteredItems.length > 50) {
      return; // Non fare nulla se ci sono più di 50 elementi
    }
    
    // Ottieni gli elementi già selezionati
    const fieldName = batchAddDialogType === 'cylinders' ? 'cylinders' : 'keys';
    let selectedItems: (ICylinderInDTO | IKeyInDTO)[] = [];
    try {
      selectedItems = data[fieldName] ? JSON.parse(data[fieldName]) : [];
    } catch (e) {
      selectedItems = [];
    }
    
    // Filtra solo gli elementi che non sono già selezionati
    const itemsToAdd = filteredItems.filter((item: ICylinderInDTO | IKeyInDTO) => 
      !selectedItems.some((selected: ICylinderInDTO | IKeyInDTO) => selected.id === item.id)
    );
    
    // Se non ci sono elementi da aggiungere, non fare nulla
    if (itemsToAdd.length === 0) {
      return;
    }
    
    // Aggiungi gli elementi filtrati
    const newSelected = [...selectedItems, ...itemsToAdd];
    
    // Rimuovi duplicati
    const uniqueSelected = newSelected.filter((item: ICylinderInDTO | IKeyInDTO, index: number, self: (ICylinderInDTO | IKeyInDTO)[]) =>
      index === self.findIndex((t) => t.id === item.id)
    );
    
    // Aggiorna i dati
    this.onChangeData(fieldName, JSON.stringify(uniqueSelected));
    
    // Chiudi la dialog
    this.closeBatchAddDialog();
  }

  renderBatchAddDialog = () => {
    const { batchAddDialogOpen, batchAddDialogType, batchAddFilterInput, data } = this.state;
    const { keys, cylinders } = this.props;
    
    if (!batchAddDialogType) return null;
    
    // Ottieni gli elementi disponibili in base al tipo
    const availableItems = batchAddDialogType === 'cylinders' 
      ? (cylinders && cylinders.content ? cylinders.content : [])
      : (keys && keys.content ? keys.content : []);
    
    // Filtra gli elementi in base all'input
    const filteredItems = batchAddFilterInput && batchAddFilterInput.trim().length > 0
      ? availableItems.filter((item: ICylinderInDTO | IKeyInDTO) => {
          const searchLower = batchAddFilterInput.toLowerCase();
          let label = '';
          if (batchAddDialogType === 'cylinders') {
            const cylinder = item as ICylinderInDTO;
            label = `[${cylinder.externalId || ""}] ${cylinder.doorName || ""} - ${cylinder.marking || ""} (${cylinder.type || ""})`.toLowerCase();
          } else {
            const key = item as IKeyInDTO;
            label = `[${key.externalId || ""}] ${key.keyFunction || ""} - ${key.designation || ""}`.toLowerCase();
          }
          return label.includes(searchLower);
        })
      : availableItems;
    
    // Ottieni gli elementi già selezionati
    const fieldName = batchAddDialogType === 'cylinders' ? 'cylinders' : 'keys';
    let selectedItems: (ICylinderInDTO | IKeyInDTO)[] = [];
    try {
      selectedItems = data[fieldName] ? JSON.parse(data[fieldName]) : [];
    } catch (e) {
      selectedItems = [];
    }
    
    const resultsLimit = 50;
    
    // Filtra solo gli elementi che non sono già selezionati (senza limite per il conteggio)
    const allItemsToAdd = filteredItems.filter((item: ICylinderInDTO | IKeyInDTO) => 
      !selectedItems.some((selected: ICylinderInDTO | IKeyInDTO) => selected.id === item.id)
    );
    
    // Limita a 50 solo per l'aggiunta effettiva
    const itemsToAdd = allItemsToAdd.slice(0, resultsLimit);
    
    const hasTooManyResults = filteredItems.length > resultsLimit;
    const canConfirm = itemsToAdd.length > 0 && !hasTooManyResults;
    
    // Determina le traduzioni in base al tipo
    const titleKey = batchAddDialogType === 'cylinders' ? 'mks.batchAddTitleCylinders' : 'mks.batchAddTitleKeys';
    const filterKey = batchAddDialogType === 'cylinders' ? 'mks.batchAddFilterCylinders' : 'mks.batchAddFilterKeys';
    
    return (
      <Dialog 
        open={batchAddDialogOpen} 
        onClose={this.closeBatchAddDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            height: '600px',
            maxHeight: '600px'
          }
        }}
      >
        <DialogTitle>
          <ReduxLanguage languageKey={titleKey} />
        </DialogTitle>
        <DialogContent style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <TextField
            fullWidth
            variant="outlined"
            label={translations.t(filterKey)}
            placeholder={translations.t(filterKey)}
            value={batchAddFilterInput}
            onChange={(e) => this.setState({ batchAddFilterInput: e.target.value })}
            style={{ marginBottom: 20 }}
            error={hasTooManyResults}
            helperText={hasTooManyResults ? translations.t('mks.batchAddTooManyResults', { limit: resultsLimit }) : ''}
          />
          <Divider style={{ marginBottom: 10 }} />
          {allItemsToAdd.length > 0 && (
            <div style={{ marginBottom: 10, padding: '8px 12px', backgroundColor: '#e3f2fd', borderRadius: '4px', color: '#1976d2', fontWeight: 'bold' }}>
              {translations.t('mks.itemsWillBeAdded', { count: allItemsToAdd.length })}
            </div>
          )}
          <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', border: '1px solid #e0e0e0', borderRadius: '4px', minHeight: 0 }}>
            {filteredItems.length > 0 ? (
              <List>
                {filteredItems.map((item: ICylinderInDTO | IKeyInDTO, index: number) => {
                  const isAlreadySelected = selectedItems.some((selected: ICylinderInDTO | IKeyInDTO) => selected.id === item.id);
                  let label = '';
                  if (batchAddDialogType === 'cylinders') {
                    const cylinder = item as ICylinderInDTO;
                    label = `[${cylinder.externalId || ""}] ${cylinder.doorName || ""} - ${cylinder.marking || ""} (${cylinder.type || ""})`;
                  } else {
                    const key = item as IKeyInDTO;
                    label = `[${key.externalId || ""}] ${key.keyFunction || ""} - ${key.designation || ""}`;
                  }
                  return (
                    <ListItem 
                      key={item.id || index} 
                      style={{ 
                        backgroundColor: isAlreadySelected ? 'rgba(100, 149, 237, 0.15)' : 'transparent',
                        borderRadius: '4px',
                        margin: '2px 4px'
                      }}
                    >
                      <ListItemText 
                        primary={
                          <span style={{ 
                            fontWeight: isAlreadySelected ? 'bold' : 'normal',
                            color: isAlreadySelected ? 'cornflowerblue' : 'inherit'
                          }}>
                            {label}
                          </span>
                        }
                        secondary={isAlreadySelected ? translations.t('mks.alreadySelected') : ''}
                      />
                    </ListItem>
                  );
                })}
              </List>
            ) : (
              <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>
                {translations.t('mks.batchAddNoResults')}
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={this.closeBatchAddDialog} 
            variant="contained"
            style={{ backgroundColor: '#d32f2f', color: 'white', marginRight: 20 }}
          >
            <ReduxLanguage languageKey={'mks.batchAddCancel'} />
          </Button>
          <Button 
            onClick={this.confirmBatchAdd} 
            variant="contained" 
            disabled={!canConfirm}
            style={{ backgroundColor: canConfirm ? '#5AC0B1' : '#ccc', color: 'white' }}
          >
            {translations.t('mks.addItems', { count: allItemsToAdd.length })}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderRequestDataFields(requestType: string, canEdit: boolean, isDisabled?: boolean) {
    const { keys, cylinders } = this.props;
    switch (requestType) {
      case MKSRequestTypeOptions.KEY_DUPLICATION:
        return this.renderDuplicateKeyFields(canEdit, isDisabled);
      case MKSRequestTypeOptions.CYLINDER_DUPLICATION:
        return this.renderDuplicateCylinderFields(canEdit, isDisabled);
      case MKSRequestTypeOptions.KEY_EXTENSION:
        return this.renderKeyExtensionFields(canEdit, cylinders, isDisabled);
      case MKSRequestTypeOptions.CYLINDER_EXTENSION:
        return this.renderCylinderExtensionFields(canEdit, keys, isDisabled);
      default:
        return null;
    }
  }

  public render() {
    const { classes, varUsers, keys, cylinders } = this.props;
    const { request, errors, plantsLoading, plantSearchInput, plantSelected, plantsOptions, assignedUser, selectedFileName, documents, data } = this.state;

    const isEdit = Boolean(this.props.request);
    const canEdit = !this.props.request || (this.props.request?.status === MKSRequestStatusOptions.DRAFT && AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.MKS_CREATE_REQUEST));
    
    // Disabilita il form se siamo in modalità creazione e non c'è un plant selezionato
    const isFormDisabled = !isEdit && (!plantSelected || !(request as IMKSRequestInDTO).plantId);
    console.warn(isFormDisabled);

    const requestLastUpdate = isEdit && this.props.request && this.props.request.history && !_.isEmpty(this.props.request.history) ?
      moment(_.last(_.orderBy(this.props.request.history, 'time')).time).format('LLL') : null;

    return (
      <div className={classes.container}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10, marginBottom: 20 }}>
          <h2 className={classes.formTitle} style={{ margin: 0, marginRight: 40 }}>
            {<ReduxLanguage languageKey={'mks.requestManagement'} />}
          </h2>
          {isEdit ? (
            <div style={{ marginLeft: 'auto', display: 'flex', flexDirection: 'row', gap: 10 }}>
              {requestLastUpdate ? (
                <h4><ReduxLanguage languageKey={'forms.lastUpdate'} languageProps={{ time: requestLastUpdate }} /></h4>
              ) : null}
              <Button
                variant="contained"
                className={classes.actionButton}
                style={{ backgroundColor: 'cornflowerblue', flexShrink: 0 }}
                onClick={() => this.onOpenRequestHistory(this.props.request)}
              >
                {<BookOutlined className={classes.icon} />}
                <h5 className={classes.actionButtonText}><ReduxLanguage languageKey={"mks.requestHistory"} /></h5>
              </Button>
              <Button
                variant="contained"
                className={classes.actionButton}
                style={{ backgroundColor: GREEN, flexShrink: 0 }}
                onClick={this.handleExportMenuOpen}
              >
                <CloudDownloadIcon className={classes.icon} />
                <h5 className={classes.actionButtonText}><ReduxLanguage languageKey={"mks.exportRequest"} /></h5>
              </Button>
              <Menu
                id="export-menu"
                anchorEl={this.state.exportMenuAnchorEl}
                keepMounted
                open={Boolean(this.state.exportMenuAnchorEl)}
                onClose={this.handleExportMenuClose}
              >
                <MenuItem onClick={this.handleGeneratePDF}>
                  <PictureAsPdfIcon className={classes.icon} style={{ color: GREEN, marginRight: 8 }} />
                  <h5 className={classes.actionButtonText}><ReduxLanguage languageKey={"mks.generatePdf"} /></h5>
                </MenuItem>
                <MenuItem onClick={this.handleGenerateXLSX}>
                  <TableChartIcon className={classes.icon} style={{ color: GREEN, marginRight: 8 }} />
                  <h5 className={classes.actionButtonText}><ReduxLanguage languageKey={"mks.generateXlsx"} /></h5>
                </MenuItem>
                <MenuItem onClick={this.handleGenerateDOCX}>
                  <DescriptionIcon className={classes.icon} style={{ color: GREEN, marginRight: 8 }} />
                  <h5 className={classes.actionButtonText}><ReduxLanguage languageKey={"mks.generateDocx"} /></h5>
                </MenuItem>
              </Menu>
            </div>
          ) : null}
        </div>

        {!isEdit ? (
          <div style={{ flex: 0, marginRight: 10, marginTop: 0 }}>
            <h5 style={{ fontWeight: 'bold', marginBottom: 8, marginLeft: 0 }}>{<ReduxLanguage languageKey={'mks.plantSearch'} />}<span style={{ color: 'red' }}>*</span></h5>
            <Autocomplete
              id="plant-search"
              style={{ width: '100%' }}
              getOptionLabel={(option) => option.label}
              options={plantsOptions}
              autoComplete
              loading={plantsLoading}
              includeInputInList
              filterSelectedOptions
              value={plantSelected}
              noOptionsText={<ReduxLanguage languageKey={plantSearchInput ? 'mks.plantSearchNoMatch' : 'mks.plantSearchEnterName'} />}
              onChange={(event, newValue) => {
                this.onPlantSelected(newValue as IDomainOptionDTO | null);
              }}
              onInputChange={(event, newInputValue) => { this.onPlantSearchInputChanged(newInputValue) }}
              renderInput={(params) => (
                <TextField
                  autoComplete='off'
                  {...params}
                  variant="outlined"
                  placeholder={translations.t('mks.plantSearchPlaceholder')}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {plantsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </div>
        ) : null}

        {isEdit ? (
          <div style={{ flex: 0, marginRight: 10, marginBottom: 10 }}>
            <Card style={{display:'flex',flexDirection:'column',padding:10}}>
              <div style={{display:'flex',flexDirection:'row',padding:10, marginTop:0, alignItems: 'center'}}>
                <UserIcon className={classes.iconCustomer} />
                <h3 style={{fontWeight: 'bold'}}>{this.props.request.customerName}</h3>
                <Button
                  variant="contained"
                  className={classes.actionButton}
                  style={{ backgroundColor:'darkcyan', flexShrink:0}}
                  onClick={() => {if (this.props.request.customerId && this.props.onOpenCustomerInfo) this.props.onOpenCustomerInfo(this.props.request.customerId)}}
                >
                  {<VisibilityIcon className={classes.icon}/>}
                  <h5 className={classes.actionButtonText}><ReduxLanguage languageKey={"recharges.seeCustomer"} /></h5>
                </Button>
              </div>
              {this.props.request.varName && 
                <div style={{display:'flex',flexDirection:'row', marginLeft: 10, marginTop: 5 }}>
                  <h3 style={{fontStyle:'italic',fontWeight:'bold',fontSize:'1.0em',display:'inline',border:'1px solid grey',borderRadius:5,marginLeft:0,paddingRight:3}}>
                    {"VAR "}
                  </h3>
                  <h3 style={{fontWeight: 'bold'}}>{this.props.request.varName}</h3>
                </div>
              }
            </Card>
          </div>
        ): null}

        <h4 style={{ marginTop: 20, marginLeft: 0, marginBottom: isEdit ? 5 : 10, fontWeight: 'bold' }}>
          {<ReduxLanguage languageKey={isEdit ? 'mks.requestType' : 'mks.selectRequestType'} />}<span style={{ color: 'red' }}>*</span>
        </h4>
        {canEdit ? (
          <Select
            value={getRequestTypeOptions().filter(e => e.value === request.requestType).length ? getRequestTypeOptions().filter(e => e.value === request.requestType)[0] : null}
            options={getRequestTypeOptions()}
            isClearable
            required
            isDisabled={isFormDisabled}
            placeholder={<ReduxLanguage languageKey={'mks.selectRequestType'} />}
            onChange={(e) => this.onChangeValue('requestType', true, e?.value)}
            formatOptionLabel={(v) => v.label}
            styles={{
              menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
              control: (styles) => ({ ...styles, height: 55 }),
            }}
          />
        ) : (
          <div style={{ marginTop: 10 }}>
            <div style={{ 
              padding: '12px 16px', 
              border: '1px solid #e0e0e0', 
              borderRadius: '4px', 
              backgroundColor: '#f9f9f9',
              fontSize: '16px',
              color: '#333',
              display: 'flex',
              alignItems: 'center'
            }}>
              {request.requestType ? getRequestTypeOptions().find(e => e.value === request.requestType)?.label || '-' : '-'}
            </div>
          </div>
        )}

        {request.requestType && this.renderRequestDataFields(request.requestType, canEdit, isFormDisabled)}

        {isEdit && varUsers && varUsers.content && varUsers.content.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <h4 style={{ fontWeight: 'bold', marginBottom: 10 }}>
              <ReduxLanguage languageKey={'mks.assignedUser'} />
            </h4>
            {canEdit ? (
              <Select
                value={assignedUser ? { value: assignedUser.id, label: assignedUser.username } : null}
                options={varUsers.content ? varUsers.content.map((user: IUserInDTO) => ({ 
                  value: user.id, 
                  label: user.username 
                })) : []}
                isClearable
                placeholder={<ReduxLanguage languageKey={'mks.selectAssignedUser'} />}
                onChange={(option) => this.onChangeAssignedUser(option ? varUsers.content.find((user: IUserInDTO) => user.id === option.value) : null)}
                styles={{
                  menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                  control: (styles) => ({ ...styles }),
                }}
              />
            ) : (
              <div style={{ 
                padding: '12px 16px', 
                border: '1px solid #e0e0e0', 
                borderRadius: '4px', 
                backgroundColor: '#f9f9f9',
                fontSize: '16px',
                color: '#333',
                display: 'flex',
                alignItems: 'center'
              }}>
                {assignedUser ? assignedUser.username : '-'}
              </div>
            )}
          </div>
        )}

        {isFormDisabled ? null : canEdit ? (
          <TextField
            id="outlined-basic"
            label={<ReduxLanguage languageKey={'mks.requestNotes'} />}
            variant="outlined"
            fullWidth
            multiline={true}
            maxRows={5}
            minRows={3}
            error={errors.notes}
            value={request.notes}
            style={{ marginTop: 20 }}
            disabled={isFormDisabled}
            onChange={e => this.onChangeValue('notes', false, e.target.value)}
          />
        ) : (
          <div style={{ marginTop: 20 }}>
            <h4 style={{ margin: 0, marginBottom: 5, fontWeight: 'bold' }}>
              <ReduxLanguage languageKey={'mks.requestNotes'} />
            </h4>
            <div style={{ 
              padding: '12px 16px', 
              border: '1px solid #e0e0e0', 
              borderRadius: '4px', 
              backgroundColor: '#f9f9f9',
              fontSize: '16px',
              color: '#333',
              minHeight: '80px',
              whiteSpace: 'pre-wrap'
            }}>
              {request.notes || '-'}
            </div>
          </div>
        )}

        {/* Rejected Notes - solo se presenti */}
        {data.rejectedNotes && (
          canEdit ? (
            <TextField
              id="rejected-notes"
              label={<ReduxLanguage languageKey={'mks.rejectedNotes'} />}
              variant="outlined"
              fullWidth
              multiline={true}
              disabled={true}
              maxRows={5}
              minRows={3}
              value={data.rejectedNotes}
              style={{ marginTop: 20 }}
            />
          ) : (
            <div style={{ marginTop: 20 }}>
              <h4 style={{ margin: 0, marginBottom: 5, fontWeight: 'bold' }}>
                <ReduxLanguage languageKey={'mks.rejectedNotes'} />
              </h4>
              <div style={{ 
                padding: '12px 16px', 
                border: '1px solid #e0e0e0', 
                borderRadius: '4px', 
                backgroundColor: '#f9f9f9',
                fontSize: '16px',
                color: '#333',
                minHeight: '80px',
                whiteSpace: 'pre-wrap'
              }}>
                {data.rejectedNotes}
              </div>
            </div>
          )
        )}

        {/* Delivery Date - solo se presente */}
        {isEdit && this.props.request?.deliveryDate && (
          canEdit ? (
            <TextField
              id="delivery-date"
              label={<ReduxLanguage languageKey={'mks.deliveryDate'} />}
              variant="outlined"
              fullWidth
              disabled={true}
              value={moment(this.props.request.deliveryDate).format('LL')}
              style={{ marginTop: 20 }}
            />
          ) : (
            <div style={{ marginTop: 20 }}>
              <h4 style={{ margin: 0, marginBottom: 5, fontWeight: 'bold' }}>
                <ReduxLanguage languageKey={'mks.deliveryDate'} />
              </h4>
              <div style={{ 
                padding: '12px 16px', 
                border: '1px solid #e0e0e0', 
                borderRadius: '4px', 
                backgroundColor: '#f9f9f9',
                fontSize: '16px',
                color: '#333'
              }}>
                {moment(this.props.request.deliveryDate).format('LL')}
              </div>
            </div>
          )
        )}

        <input type='file' style={{display: 'none'}} ref={this.inputFileRef} 
          onChange={(e) => {
            if(e.target.files && e.target.files.length > 0) {
              if (selectedFileName === null)
                this.onNewInputFile(e.target.files[0])
              else
                this.onNewInputFileConfirmed(e.target.files[0],null,null)
              e.target.value = null
            }
          }}
        />
        {!isFormDisabled && (
          <h4 style={{ fontWeight: 'bold', marginTop:20 }}>{<ReduxLanguage languageKey={'mks.requestFiles'} />}</h4>
        )}
        {documents.map((document,index) => (
          <Card key={index}
            style={{padding:10,backgroundColor:'white',display:'flex',flexDirection:'row', 
            alignItems:'center',marginTop:10,marginBottom:10,minHeight:'34px',}} elevation={2}>
            <div style={{fontWeight:'bold',minHeight:'18px',maxWidth:'70%',overflow:'hidden',textOverflow:'ellipsis',fontSize:'0.8em'}}>
              {document.name}
            </div>
            <span style={{flexGrow:'1'}}/>
            {document.url?(
              <a href={document.url}>
                <Button
                  variant="contained"
                  style={{backgroundColor:'darkcyan'}}
                  className={classes.actionButton}
                >
                  <CloudDownloadIcon className={classes.icon}/>
                  <h5 className={classes.actionButtonText}><ReduxLanguage languageKey="activations.selloutFilesDownload" /></h5>
                </Button>
              </a>
            ):null}
            {canEdit && (
              <Button
                variant="contained"
                style={{backgroundColor:'#282c34'}}
                className={classes.actionButton}
                disabled={isFormDisabled}
                onClick={(e) => {
                  this.setState({selectedFileName:document.name})
                  if (this.inputFileRef&&this.inputFileRef.current)
                    this.inputFileRef.current.click();
                }}
              >
                <RedoIcon className={classes.icon}/>
                <h5 className={classes.actionButtonText}><ReduxLanguage languageKey="activations.selloutFilesReplace" /></h5>
              </Button>
            )}
          </Card>
        ))}
        {canEdit && (
          <Button
            variant="contained"
            style={{backgroundColor:'#282c34', marginTop:10}}
            className={classes.actionButton}
            onClick={(e) => {
              this.setState({selectedFileName:null})
                if (this.inputFileRef&&this.inputFileRef.current)
                  this.inputFileRef.current.click();
            }}
          >
            <CloudUploadIcon className={classes.icon}/>
            <h5 className={classes.actionButtonText}><ReduxLanguage languageKey="activations.selloutFilesAdd" /></h5>
          </Button>
        )}

        {canEdit ? (
          <div style={{ position: 'sticky', bottom: '0', paddingTop: '20px', backgroundColor: 'white', marginLeft: '-5px', marginRight: '-5px', zIndex: 1 }}>
            <Button
              variant="contained"
              disabled={!canEdit || !this.canSubmitForm()}
              style={{ width: '100%', opacity: canEdit && this.canSubmitForm() ? 1 : 0.5, backgroundColor: '#5AC0B1', color: 'white', marginTop: 50, height: 45, fontWeight: 'bold' }}
              onClick={() => this.onSubmitForm()}
            >
              <ReduxLanguage languageKey="forms.save" />
            </Button>
          </div>
        ) : null}
        {this.renderBatchAddDialog()}
        {this.renderPdfDialog()}
      </div>
    );
  }

  renderPdfDialog = () => {
    const { pdfDialogOpen, pdfBlobUrl } = this.state;
    
    return (
      <Dialog 
        open={pdfDialogOpen} 
        onClose={this.closePdfDialog}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            height: '90vh',
            maxHeight: '90vh'
          }
        }}
      >
        <DialogTitle>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <ReduxLanguage languageKey={'mks.requestPdf'} />
            <Button onClick={this.closePdfDialog} variant="contained" style={{ backgroundColor: '#d32f2f', color: 'white' }}>
              <ReduxLanguage languageKey={'forms.close'} />
            </Button>
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
          {pdfBlobUrl ? (
            <embed 
              src={pdfBlobUrl} 
              type="application/pdf" 
              style={{ width: '100%', height: '100%', border: 'none', flex: 1 }}
            />
          ) : null}
        </DialogContent>
      </Dialog>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    varUsers: state.vars.users.data,
    VAR: state.vars.VAR.data,
    keys: state.mks.keys.data,
    cylinders: state.mks.cylinders.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(MKSRequestForm));
